// src/group.js
// Pure grouping logic for the advisories board (no DOM, no CSS import — unit
// tested in test/group.test.mjs).

export const SOURCE_ORDER = ['US', 'CA', 'DE', 'GB', 'FR'];

// One row per (ministry, destination) → one card per destination. The card's
// headline level is the AVERAGE of the ministries' normalized levels rounded
// to the nearest integer (half up) — one pessimistic outlier no longer sets
// the tone; the per-ministry badges keep every individual rating visible.
export function groupByDestination(advisories) {
  const byDest = new Map();
  for (const a of advisories) {
    if (!a.iso2) continue;
    if (!byDest.has(a.iso2)) byDest.set(a.iso2, []);
    byDest.get(a.iso2).push(a);
  }
  const groups = [...byDest.entries()].map(([iso2, rows]) => {
    rows.sort((x, y) => SOURCE_ORDER.indexOf(x.source) - SOURCE_ORDER.indexOf(y.source));
    const levels = rows.map((r) => r.level).filter((l) => l != null);
    const level = levels.length ? Math.round(levels.reduce((a, b) => a + b, 0) / levels.length) : 0;
    // The headline advisory (summary + read link): closest to the average
    // level, most recent among ties — representative, not alarmist.
    const top = rows
      .slice()
      .sort(
        (x, y) =>
          Math.abs((x.level ?? 0) - level) - Math.abs((y.level ?? 0) - level) ||
          Date.parse(y.date || 0) - Date.parse(x.date || 0),
      )[0];
    const latest = rows.reduce((m, r) => {
      const t = Date.parse(r.date || 0) || 0;
      return t > m ? t : m;
    }, 0);
    return { iso2, rows, level, top, latest };
  });
  groups.sort((x, y) => y.latest - x.latest);
  return groups;
}
